import protoRoot from "../proto-root";
import createMessage from "./createMessage";

const name = "babyStationAudioStateMessage";

function create({ state }) {
  const BabyStationAudioStateMessage = protoRoot.lookupType(
    "comm.BabyStationAudioStateMessage"
  );
  const BabyStationAudioState = BabyStationAudioStateMessage.lookupEnum(
    "BabyStationAudioState"
  );

  const message = BabyStationAudioStateMessage.create({
    state: BabyStationAudioState.values[state]
  });

  return createMessage({ [name]: message });
}

export default {
  create,
  name
};

// message BabyStationAudioStateMessage {
//   enum BabyStationAudioState {
//       AUDIO_LOST_TEMPORARLY = 0;      // phone call on iOS - not recording temporaly
//       AUDIO_ON_AGAIN = 1;             // voice recovered, monitoring continue
//   }
//   enum InterruptionReason {
//       DEFAULT = 0;
//       BUILT_IN_MIC_MUTED = 1; // device mutes the built-in microphone
//   }
//   BabyStationAudioState state = 1;
//   InterruptionReason interruptionReason = 2;
// }
